import { CircleAlert, createElement, X } from "lucide";

// Shows a red alert in the layout's flash container, replacing what is there.
// Same markup as layouts/_flash_message: an icon, the text, and an x button
// (flash controller) that dismisses it. Alerts never auto-fade.
export function showErrorFlash(message) {
  const container = document.querySelector("[data-flash-container]");
  if (!container) return;

  const flash = document.createElement("div");
  flash.setAttribute("role", "alert");
  flash.dataset.controller = "flash";
  flash.className =
    "flash-message alert bg-red-50 dark:bg-red-950/40 text-red-800 dark:text-red-200 border border-red-200 dark:border-red-900 rounded-lg p-4 mb-3 transition-opacity duration-500 motion-reduce:transition-none";

  const row = document.createElement("div");
  row.className = "flex items-center space-x-3";
  row.appendChild(icon(CircleAlert));

  const text = document.createElement("span");
  text.className = "min-w-0 flex-1";
  text.textContent = message;
  row.appendChild(text);

  const close = document.createElement("button");
  close.type = "button";
  close.setAttribute("aria-label", "Dismiss");
  close.dataset.action = "flash#dismiss";
  close.className =
    "-m-1 shrink-0 rounded p-1 hover:bg-black/5 dark:hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-current";
  close.appendChild(icon(X));
  row.appendChild(close);

  flash.appendChild(row);
  container.replaceChildren(flash);
}

// Lucide's createElement returns a bare <svg>; add the class that sizes it to
// the inherited font size, matching the server-rendered icons.
function icon(node) {
  const svg = createElement(node);
  svg.classList.add("icon");
  return svg;
}
